import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

import SettingsSectionOverline from './SettingsSectionOverline';
import { UserSubscription } from 'types';
import { SubscriptionCard } from 'components/SubscriptionCard';
import { useCustomerPortal } from 'hooks';

const StyledBox = styled(Box)(({ theme: { spacing } }) => ({
  marginBottom: spacing(8),
  '& > .MuiBox-root': {
    marginBottom: spacing(6),
  },
}));

export interface SubscriptionsGroupProps {
  subscriptions: UserSubscription[];
  title: string;
}

const SubscriptionsGroup = ({
  subscriptions,
  title,
}: SubscriptionsGroupProps): JSX.Element => {
  const { customerPortal } = useCustomerPortal();

  const handleChangePlan = () => {
    customerPortal();
  };

  return (
    <StyledBox>
      <SettingsSectionOverline text={title} />
      {subscriptions.map(
        ({
          subscriptionId,
          subscription,
          isCanceled,
          renewalDate,
          price,
          duration,
          canBeUpdated,
          purchaseSource,
        }) => (
          <SubscriptionCard
            canBeUpdated={canBeUpdated}
            duration={duration}
            isCanceled={isCanceled}
            key={subscription}
            onChangePlan={handleChangePlan}
            price={price}
            purchaseSource={purchaseSource}
            renewsDate={renewalDate}
            subscription={subscription}
            subscriptionId={subscriptionId}
          />
        )
      )}
    </StyledBox>
  );
};

export default SubscriptionsGroup;
